import Vue from "vue";
import Router from "vue-router";

import store from "@/store";
import LoginComponent from "@/views/login/login.vue";
import AuthRedirecting from "@/views/auth-redirecting.vue";
import AppComponent from "@/views/app/app.vue";
import MapComponent from "@/views/app/map/map.vue";
import BookComponent from "@/views/app/book/book.vue";
import ChartsComponent from "@/views/app/charts/charts.vue";
import ModellingComponent from "@/views/app/modelling/modelling";
import TrafficCountComponent from "@/views/app/traffic-count/traffic-count";
import PublicTransportComponent from "@/views/app/public-transport/public-transport";
import SituationCenter from "@/views/app/situation-center/situation-center";
import ScenarioModelling from "@/views/app/scenario-modelling/scenario-modelling";
import UserRolesComponent from "@/views/app/user-roles/user-roles";
import ProposalComponent from "@/views/app/proposal/proposal";
import EventEditor from "@/views/app/event-editor/event-editor";
import IconsPreview from "@/views/app/icons-preview/icons-preview";
import Calculations from "@/views/app/calculations/calculations";
import CModelList from "@/views/app/calculations/models/list";
import CModel from "@/views/app/calculations/models/model/model";
import CScenarioList from "@/views/app/calculations/models/model/scenarios/list";
import CScenarioEditor from "@/views/app/calculations/models/model/scenarios/editor";
// import CScenarioDiff from "@/views/app/calculations/models/model/scenarios/diff";
import CScenario from "@/views/app/calculations/models/model/scenarios/scenario";

const defaultPath = store.getters.getDefaultPath;
const ifAuthenticated = (to, from, next) => {
  if (store.state.isReadyToRender) {
    next();
    return;
  }
  next("/login");
};

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/app",
      name: "app",
      component: AppComponent,
      beforeEnter: ifAuthenticated,
      children: [
        {
          name: "map",
          path: "map",
          component: MapComponent
        },
        {
          name: "book",
          path: "book",
          component: BookComponent
        },
        {
          name: "charts",
          path: "charts",
          component: ChartsComponent
        },
        {
          name: "modelling",
          path: "modelling",
          component: ModellingComponent
        },
        {
          name: "traffic-count",
          path: "traffic-count",
          component: TrafficCountComponent
        },
        {
          name: "public-transport",
          path: "public-transport",
          component: PublicTransportComponent
        },
        {
          name: "situation-center",
          path: "situation-center",
          component: SituationCenter,
          meta: {
            auth: true,
            title: "RITM - Ситуационный центр",
            metaTags: [
              {
                name: "description",
                content: "RITM - Ситуационный центр"
              },
              {
                name: "viewport",
                content: "width=1400"
              }
            ]
          }
        },
        {
          name: "scenario-modelling",
          path: "scenario-modelling",
          component: ScenarioModelling
        },
        {
          name: "event-editor",
          path: "event-editor",
          component: EventEditor
        },
        {
          name: "user-roles",
          path: "user-roles",
          component: UserRolesComponent,
          props: r => ({ query: r.query.id })
        },
        {
          name: "proposal",
          path: "proposal",
          component: ProposalComponent,
          props: r => ({ query: r.query.id })
        },
        {
          name: "calculations",
          path: "calculations",
          component: Calculations,
          redirect: "/app/calculations/list",
          children: [
            {
              name: "c-models",
              path: "list",
              component: CModelList
            },
            {
              name: "c-model",
              path: ":modelId",
              component: CModel,
              redirect: "/app/calculations/:modelId/list",
              children: [
                {
                  name: "c-scenarios",
                  path: "list",
                  component: CScenarioList
                },
                {
                  name: "c-editor",
                  path: "editor",
                  component: CScenarioEditor
                },
                {
                  name: "c-scenario",
                  path: ":scenarioId",
                  component: CScenario
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: LoginComponent
    },
    {
      path: "/oauth/token/:token",
      name: "oauth",
      component: AuthRedirecting
    },
    {
      name: "all-routes",
      path: "*",
      redirect: defaultPath
    },
    {
      path: "/icons-preview",
      name: "icons-preview",
      component: IconsPreview
    }
  ]
});
